import { render, staticRenderFns } from "./EditHotelServiceOne.vue?vue&type=template&id=1b60578c&scoped=true"
import script from "./EditHotelServiceOne.vue?vue&type=script&lang=js"
export * from "./EditHotelServiceOne.vue?vue&type=script&lang=js"
import style0 from "./EditHotelServiceOne.vue?vue&type=style&index=0&id=1b60578c&prod&scoped=true&lang=scss"
import style1 from "./EditHotelServiceOne.vue?vue&type=style&index=1&id=1b60578c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b60578c",
  null
  
)

export default component.exports